import React, { useState, useEffect } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { DialogActions } from "@material-ui/core";
import { onPreventEnterSubmitting, setObject } from "../../../../utils/utils";
import { saveCustomer } from "../../../../services/sales/customerService";
import Swal from "sweetalert2";
import { getLeadMasterDataAPI } from "../../../../services/crm/leadService";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchGlAccount from "../../setup/finance/searchGlAccount";
import { Card } from "react-bootstrap";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import store from "../../../../store/store";
import {
  FormSelectField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import MapPlaces from "../../../../partials/content/MapPlaces";
const ConvertToCustomerForm = ({
  history,
  lead = {
    ID: 0,
  },
  salesCardID = 0,
  onCloseDialog,
  onReloadLeads,
  onConfirmSave,
}) => {
  const [customerGroupOptions, setCustomerGroupOptions] = useState([]);
  const [industryTypeOptions, setIndustryTypeOptions] = useState([]);
  const [businessSizeOptions, setBusinessSizeOptions] = useState([]);
  const [sourceOptions, setSourceOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [openSearchGlAccount, setOpenSearchGlAccount] = useState(false);
  const [openSearchMapPlaces, setOpenSearchMapPlaces] = useState(false);
  const { companyProfile, socket } = useGlobalData();
  let convertToCustomerData = {
    ID: 0,
    leadID: lead.ID,
    customerGroupID: 1,
    customerName: "",
    contactName: "",
    position: "",
    contactEmail: "",
    contactPhone: "",
    website: "",
    taxpayerID: "",
    industryTypeID: 0,
    businessSizeID: 0,
    sourceID: 0,
    addressEmail: "",
    addressPhone: "",
    address: "",
    city: "",
    province: "",
    countryCode: companyProfile.countryCode,
    postalCode: "",
  };
  if (lead && lead.ID > 0) {
    convertToCustomerData = {
      ID: 0,
      leadID: lead.ID,
      customerGroupID: lead.customerGroupID,
      customerName: lead.leadName,
      contactName: lead.contactName,
      position: lead.position,
      contactEmail: lead.contactEmail,
      contactPhone: lead.contactPhone,
      website: lead.website,
      taxpayerID: lead.taxpayerID,
      industryTypeID: lead.industryTypeID,
      industryTypeName: lead.industryType.industryTypeName,
      businessSizeID: lead.businessSizeID,
      businessSizeName: lead.businessSize.businessSizeName,
      sourceID: lead.sourceID,
      sourceName: lead.source.sourceName,
      addressEmail: lead.contactEmail,
      addressPhone: lead.contactPhone,
      address: lead.address,
      city: lead.city,
      province: lead.province,
      countryCode: lead.countryCode,
      postalCode: lead.postalCode,
    };
  }

  useEffect(() => {
    const { auth } = store.getState();

    async function getLeadMasterData() {
      const response = await getLeadMasterDataAPI();
      const { data } = response.data;
      const {
        businessSize,
        industryType,
        source,
        countries,
        customerGroup,
      } = data;
      setMasterData(
        industryType,
        businessSize,
        source,
        countries,
        customerGroup
      );
    }

    getLeadMasterData();

    if (lead && lead.ID > 0) {
      setObject(socket, "lock", lead.ID, "LEAD", auth.user)
        .then((response) => {})
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (lead && lead.ID > 0) {
        setObject(socket, "release", lead.ID, "LEAD", auth.user);
      }
    };
  }, [lead]);

  const convertToCustomerFormSchema = yup.object().shape({
    ID: yup.number().default(convertToCustomerData.ID),
    customerName: yup
      .string()
      .required("Customer Name is required")
      .max(255, "Customer Name maximum characters is 255"),
    contactName: yup
      .string()
      .required("Contact Name is required")
      .max(255, "Contact Name maximum characters is 255"),
    position: yup
      .string()
      .required("Position is required")
      .max(50, "Position maximum characters is 50"),
    website: yup
      .string()
      .matches(
        /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/,
        "Website url must be valid. e.g. https://invifo.com or www.invifo.com"
      )
      .max(50, "Website maximum characters is 50"),
    taxpayerID: yup.string().max(50, "Taxpayer ID maximum characters is 50"),
    contactPhone: yup
      .string()
      .required("Phone Number is required")
      .matches(
        /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
        "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
      )
      .max(50, "Phone Number maximum characters is 50"),
    contactEmail: yup
      .string()
      .email("Email must be valid. e.g. joe@invifo.com")
      .required("Email is required")
      .max(50, "Email maximum characters is 50"),
    industryTypeName: yup.string(),
    businessSizeName: yup.string(),
    sourceName: yup.string(),
    address: yup
      .string()
      .required("Address is required")
      .max(255, "Address maximum characters is 255"),
    city: yup
      .string()
      .required("City is required")
      .max(50, "City maximum characters is 50"),
    province: yup.string().max(50, "Province maximum characters is 50"),
    countryCode: yup.string(),
    postalCode: yup.string().max(10, "Postal Code maximum characters is 10"),
  });

  return (
    <Formik
      initialValues={convertToCustomerData}
      validationSchema={convertToCustomerFormSchema}
      enableReinitialize={true}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        if (salesCardID > 0) {
          onConfirmSave(values);
        } else {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to convert this Lead become Customer ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, convert it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveCustomer(values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Converted",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  history.push("/sales/customers");
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Card>
                <Card.Header>
                  <i className="fas fa-th-large"></i>
                  <span>
                    <strong>Customer Basic Info</strong>
                  </span>
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <FormTextField
                        label="Customer Name"
                        name="customerName"
                      />
                      <FormSelectField
                        label="Customer Group"
                        name="customerGroupID"
                        options={customerGroupOptions}
                      />
                      <FormTextField label="Contact Name" name="contactName" />
                      <FormTextField label="Position" name="position" />
                      <FormTextField label="Website" name="website" />
                      <FormTextField
                        label="Taxpayer Identification Number"
                        name="taxpayerID"
                      />
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <FormTextField label="Phone Number" name="contactPhone" />
                      <FormTextField label="Email" name="contactEmail" />
                      <FormSelectField
                        label="Industry Type"
                        name="industryTypeID"
                        options={industryTypeOptions}
                      />
                      <FormSelectField
                        label="Business Size"
                        name="businessSizeID"
                        options={businessSizeOptions}
                      />
                      <FormSelectField
                        label="Source"
                        name="sourceID"
                        options={sourceOptions}
                      />
                      <FormTextField
                        label="Receivable Account"
                        name="receivableAccountName"
                        searchButton
                        clearButton
                        onSearchClick={() => {
                          setOpenSearchGlAccount(true);
                        }}
                        onClearFields={() => {
                          setFieldValue(`receivableAccountID`, 0);
                          setFieldValue(`receivableAccountName`, "");
                        }}
                        readonly
                      />
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <FormTextField
                        label="Address"
                        name="address"
                        mapsButton
                        onMapsClick={() => {
                          setOpenSearchMapPlaces(true);
                        }}
                      />
                      <FormTextField label="City" name="city" />
                      <FormTextField label="Province / State" name="province" />
                      <FormSelectField
                        label="Country"
                        name="countryCode"
                        options={countryOptions}
                      />
                      <FormTextField label="Postal Code" name="postalCode" />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
          <DialogActions>
            {salesCardID > 0 ? (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={onCloseDialog}
                >
                  <i className="fas fa-window-close"></i>
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary btn-md btn-pill btn-bold"
                  disabled={isSubmitting}
                >
                  <i className="fas fa-arrow-circle-right"></i>
                  Next
                </button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={onCloseDialog}
                >
                  <i className="fas fa-window-close"></i>
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-success btn-md btn-pill btn-bold"
                  disabled={isSubmitting}
                >
                  <i className="fas fa-save"></i>
                  Convert
                </button>
              </React.Fragment>
            )}
          </DialogActions>
          <DialogLayout
            open={openSearchGlAccount}
            title="Search GL Account"
            onCloseDialog={() => {
              setOpenSearchGlAccount(false);
            }}
            maxWIdth="md"
          >
            <SearchGlAccount
              accountTypeID="4"
              onSelectGlAccount={(account) => {
                setFieldValue(`receivableAccountID`, account.ID);
                setFieldValue(`receivableAccountName`, account.accountName);
                setOpenSearchGlAccount(false);
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchGlAccount(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchMapPlaces}
            title="Search Address on Maps"
            onCloseDialog={() => {
              setOpenSearchMapPlaces(false);
            }}
            maxWIdth="lg"
            minHeight={true}
          >
            <MapPlaces
              address={values.address}
              city={values.city}
              province={values.province}
              countryCode={values.countryCode}
              postalCode={values.postalCode}
              onPinLocation={(
                selectedFormattedAddress,
                selectedShortAddressComponents,
                selectedLongAddressComponents,
                selectedAddress,
                selectedCity,
                selectedProvince,
                selectedCountryCode,
                selectedPostalCode
              ) => {
                setFieldValue(`address`, selectedAddress);
                setFieldValue(`city`, selectedCity);
                setFieldValue(`province`, selectedProvince);
                setFieldValue(`countryCode`, selectedCountryCode);
                setFieldValue(`postalCode`, selectedPostalCode);
                setOpenSearchMapPlaces(false);
              }}
              onCloseDialog={() => {
                setOpenSearchMapPlaces(false);
              }}
            />
          </DialogLayout>
        </form>
      )}
    </Formik>
  );

  function setMasterData(
    industryTypes = [],
    businessSizes = [],
    sources = [],
    countries = [],
    customerGroup = []
  ) {
    let industryTypeOptionsTmp = [];
    let businessSizeOptionsTmp = [];
    let sourceOptionsTmp = [];
    let countryOptionsTmp = [];
    let customerGroupOptionsTmp = [];
    if (typeof industryTypes !== "undefined") {
      industryTypes.forEach((industryType) => {
        industryTypeOptionsTmp.push({
          value: industryType.ID,
          label: industryType.industryTypeName,
        });
      });
    }

    if (typeof businessSizes !== "undefined") {
      businessSizes.forEach((businessSize) => {
        businessSizeOptionsTmp.push({
          value: businessSize.ID,
          label: businessSize.businessSizeName,
        });
      });
    }

    if (typeof sources !== "undefined") {
      sources.forEach((source) => {
        sourceOptionsTmp.push({
          value: source.ID,
          label: source.sourceName,
        });
      });
    }
    if (typeof countries !== "undefined") {
      countries.forEach((country) => {
        countryOptionsTmp.push({
          value: country.countryCode,
          label: country.countryName,
        });
      });
    }

    if (typeof customerGroup !== "undefined") {
      customerGroup.forEach((group) => {
        customerGroupOptionsTmp.push({
          value: group.ID,
          label: group.groupName,
        });
      });
    }
    setIndustryTypeOptions(industryTypeOptionsTmp);
    setBusinessSizeOptions(businessSizeOptionsTmp);
    setSourceOptions(sourceOptionsTmp);
    setCountryOptions(countryOptionsTmp);
    setCustomerGroupOptions(customerGroupOptionsTmp);
  }
};

export default ConvertToCustomerForm;
